<template>
  <div class="accounting-information-content">
    <v-container container--fluid grid-list-md>
       <v-row justify="space-between">
        <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
          <v-text-field
            v-if="item.type === 'text'"
            outlined
            :ref="item.key"
            :label="item.text"
            v-model="clientInfo[item.key]"
            :error="isFieldInvalid(item.key)"
          ></v-text-field>
          <v-select
            outlined
            :items="item.selectItems"
            v-if="item.type === 'select'"
            v-model="clientInfo[item.key]"
            :label="item.text"
            :error="isFieldInvalid(item.key)"
          ></v-select>
          <v-switch
            v-if="item.type === 'switch'"
            v-model="clientInfo[item.key]"
            :label="item.text"
          ></v-switch>
        </v-col>
       </v-row>
    </v-container>
  </div>
</template>

<script>
  // @group EditClient
  // Client Accounting Information tab for EditClient
  export default {
    name: "AccountingInformation",
    props: {
      // Client Object
      clientInfo: Object,
    },
    data() {
      return {
        items: [
          {text: 'Legal Name', key: 'legal_name', type: 'text'},
          {text: 'ABN', key: 'abn', type: 'text'},
          {text: 'Accounting Address', key: 'accounting_address', type: 'text'},
          {text: 'Suburb', key: 'accounting_suburb', type: 'text'},
          {text: 'State', key: 'accounting_state', type: 'text'},
          {text: 'Postcode', key: 'accounting_postcode', type: 'text'},
          {text: 'Telephone', key: 'accounting_phone', type: 'text'},
          {text: 'Contact Name', key: 'accounting_contact_name', type: 'text'},
          {text: 'Contact Phone', key: 'accounting_contact_phone', type: 'text'},
          {text: 'Contact Email', key: 'accounting_contact_email', type: 'text'},
          {text: 'Payment Terms', key: 'payment_terms', type: 'select', selectItems: ['7 Days','14 Days','21 Days','28 Days']},
          {text: 'Oracle Account Number', key: 'oracle_account_number', type: 'text'},
          {text: 'Oracle Site Number', key: 'oracle_site_number', type: 'text'},
          {text: 'Send CSV Invoice', key: 'send_csv_invoice', type: 'switch'},
        ]
      }
    },
    computed: {
      invalidFields() {
        return this.$store.state.invalidFields || [];
      },
      isFieldInvalid() {
        return (fieldName) => this.invalidFields.includes(fieldName);
      }
    },
    methods: {
      // @vuese
      // Scrolls to and focuses the Oracle Site Number field (refs on v-for
      // are arrays). Retries because the field may not be mounted yet when
      // the enclosing expansion panel is still animating open.
      focusOracleSiteNumber(attempt = 0) {
        this.$nextTick(() => {
          const field = this.$refs.oracle_site_number;
          const target = Array.isArray(field) ? field[0] : field;
          if (target && typeof target.focus === 'function') {
            // Focus and scroll after the expansion-panel open animation has
            // settled. Focusing while the panel is still animating in does
            // not stick, and scrolling early computes the wrong position.
            setTimeout(() => {
              target.focus();
              if (target.$el && typeof target.$el.scrollIntoView === 'function') {
                target.$el.scrollIntoView({behavior: 'smooth', block: 'center'});
              }
            }, 350);
          } else if (attempt < 20) {
            setTimeout(() => this.focusOracleSiteNumber(attempt + 1), 50);
          }
        });
      }
    }

  }
</script>

<style scoped>
.accounting-information-content {
  /* Parent provides padding */
}

.v-text-field {
  margin-bottom: 8px;
}

.v-select {
  margin-bottom: 8px;
}

.v-text-field.v-text-field--outlined >>> .v-input__control {
  min-height: 56px;
}

.v-text-field.v-text-field--outlined >>> .v-input__slot {
  min-height: 48px;
}

.v-select.v-select--outlined >>> .v-input__control {
  min-height: 56px;
}

.v-select.v-select--outlined >>> .v-input__slot {
  min-height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/AccountingInformation.vue